function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from 'react';
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { SignupRequestData } from "src/data/signuprequest/SignupRequestData";
import LoadableObjContainer from "nood-comp/src/comp/ui/containers/LoadableObjContainer";
import ObjectViewer from "nood-comp/src/comp/object-viewer/ObjectViewer";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import TwoCol from "nood-comp/src/comp/ui/containers/TwoCol";
import Div from "nood-comp/src/comp/ui/containers/Div";
import Space from "nood-comp/src/comp/ui/space/Space";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import Tag from "nood-comp/src/comp/ui/tag/Tag";
import { useDocumentTitle } from "usehooks-ts";
import { msg } from "src/app/msg";
import Button from "nood-comp/src/comp/button/Button";
import { useModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import Form from "nood-comp/src/comp/form/Form";
import { __get, _put } from "nood-comp/src/net/xhr";
import { ClosestElementRegistryContext } from "nood-comp/src/contexts/contexts";
import OptionPicker from "nood-comp/src/comp/form/dropdown/OptionPicker";
export default function SignupRequestView(props) {
  useDocumentTitle(msg.title('Signup Request / ...'));
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    signuprequest = _useState2[0],
    set_signuprequest = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    set_errors = _useState4[1];
  var id = useURLParam('id');
  useEffect(function () {
    if (id) {
      new SignupRequestData().one(id, set_signuprequest, set_errors, function (resp) {
        var _resp$data;
        if (resp !== null && resp !== void 0 && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.id) {
          document.title = msg.title(['Signup Request', resp.data.username]);
        }
      });
    }
  }, [id]);
  useEffect(function () {
    if (signuprequest) {}
  }, [signuprequest]);
  return /*#__PURE__*/React.createElement(LoadableObjContainer, {
    obj: signuprequest
  }, signuprequest && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TwoCol, {
    col2InitWidth: 350,
    col1: /*#__PURE__*/React.createElement(View, {
      obj: signuprequest
    }),
    col2: /*#__PURE__*/React.createElement(Actions, {
      signupRequest: signuprequest
    })
  })));
}
var View = function View(props) {
  var signUpRequest = props.obj;
  return /*#__PURE__*/React.createElement(Div, {
    pad: 30
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-title"
  }, signUpRequest.display_name), /*#__PURE__*/React.createElement(Space, {
    count: 2
  }), /*#__PURE__*/React.createElement(Tag, {
    value: signUpRequest.status,
    color: signUpRequest.status_color
  })), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 1
  }), /*#__PURE__*/React.createElement(Icon, {
    color: "var(--shade-40)",
    icon: "at-sign"
  }), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, signUpRequest.username), /*#__PURE__*/React.createElement(Space, null), /*#__PURE__*/React.createElement(Space, null), /*#__PURE__*/React.createElement(Icon, {
    color: "var(--shade-40)",
    icon: "inbox"
  }), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, signUpRequest.email_address), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 15
  }), /*#__PURE__*/React.createElement(ObjectViewer, {
    obj: {
      signup_key: signUpRequest.request_key,
      status: signUpRequest.status
    },
    fields: {
      signup_key: {
        icon: "key"
      },
      status: {
        icon: "loader"
      },
      created: {
        icon: "clock"
      }
    }
  }));
};
var Actions = function Actions(props) {
  var _useState5 = useState(function () {
      return {
        status: props.signupRequest.status
      };
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    formObj = _useState6[0],
    setFormObj = _useState6[1];
  var signupRequest = props.signupRequest;
  var requestID = useURLParam('id');
  var modalCtx = useModalContext();
  var closestCtx = useContext(ClosestElementRegistryContext);
  var _sendEmail = function _sendEmail() {
    modalCtx.__confirm('Are you sure you want to send signup link to this account?', {
      title: "Send Signup Link",
      primary: {
        icon: "send",
        label: "Send Signup Email",
        __do: function __do(modIdx, ops) {
          ops.setIsProcessing(true);
          __get("/request_invite/".concat(requestID, "?command=send"), {}, function (res) {
            ops.setIsProcessing(false);
            ops.onAfterDo(res, function () {});
          });
        }
      },
      secondary: {
        icon: "x",
        label: "Cancel"
      }
    });
  };
  return /*#__PURE__*/React.createElement(Div, {
    pad: 15
  }, "Invite this Organization:", /*#__PURE__*/React.createElement(Spacer, {
    mtop: 3
  }), /*#__PURE__*/React.createElement(Button, {
    label: 'Send Signup Email',
    icon: "send",
    primary: true,
    __click: function __click() {
      _sendEmail();
    },
    style: {
      margin: 0
    }
  }), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), /*#__PURE__*/React.createElement(Form, {
    obj: formObj,
    __setter: setFormObj
  }, /*#__PURE__*/React.createElement(OptionPicker, {
    name: "status",
    label: "Set Status",
    options: [{
      code: 'NEW',
      value: "NEW",
      description: "A new request",
      icon: "plus"
    }, {
      code: 'EMAIL_SENT',
      value: "EMAIL_SENT",
      description: "The signup email has been sent",
      icon: "send"
    }, {
      code: 'INVALID',
      value: "INVALID",
      description: "Tag as non-usable signup link",
      icon: "x"
    }, {
      code: 'USED',
      value: "USED",
      description: "The organization has signed-up",
      icon: "check"
    }],
    icon: "loader",
    __pick: function __pick(chosenOpt) {
      modalCtx.__confirm("Are you sure you want to update this record's status to: ".concat(chosenOpt.value), {
        title: "Change Status",
        primary: {
          icon: "check",
          label: "Change Status",
          __do: function __do(idx, operations) {
            operations.setIsProcessing(true);
            _put("/request_invite/".concat(signupRequest.id), {
              status: chosenOpt.value
            }, function (res) {
              operations.setIsProcessing(false);
              operations.onAfterDo(res, function () {
                var _res$http;
                if (((_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200) {
                  setFormObj({
                    status: chosenOpt.value
                  });
                } else {
                  setFormObj({
                    status: formObj.status
                  });
                }
              });
            });
          }
        }
      });
    }
  })));
};